import { DEFAULT_STATE } from '../constants'
import { searchPageStore } from '../index'

/**
 * Sets the designers array
 * @param {string[]} designers - Array of designer strings
 */
export const setDesigners = (designers) => {
  searchPageStore.setState({ designers })
}

/**
 * Adds a designer to the array
 * @param {string} designer - Designer to add
 */
export const addDesigner = (designer) => {
  const state = searchPageStore.getState()
  const currentDesigners = state.designers || []

  if (!currentDesigners.includes(designer)) {
    searchPageStore.setState({ designers: [...currentDesigners, designer] })
  }
}

/**
 * Removes a designer from the array
 * @param {string} designer - Designer to remove
 */
export const removeDesigner = (designer) => {
  const state = searchPageStore.getState()
  const currentDesigners = state.designers || []

  searchPageStore.setState({
    designers: currentDesigners.filter((d) => d !== designer),
  })
}

/**
 * Clears all designers filter
 */
export const clearDesigners = () => {
  searchPageStore.setState({ designers: DEFAULT_STATE.designers })
}
